document.addEventListener('DOMContentLoaded', function () {
  const heroSliders = document.querySelectorAll('.hero-swiper');

  heroSliders.forEach((slider) => {
    const section = slider.closest('.hero-slider');

    const autoplay = section.dataset.autoplay === 'true';
    const speed = parseInt(section.dataset.speed) || 5000;

    new Swiper(slider, {
      loop: true,
      effect: "fade",
      speed: 1200,
      autoplay: autoplay
        ? {
            delay: speed,
          }
        : false,
    });
  });


  const bestSliders = document.querySelectorAll('.products-slider');

  bestSliders.forEach(slider => {
    const mobile = parseFloat(slider.dataset.slidesMobile) || 1;
    const tablet = parseFloat(slider.dataset.slidesTablet) || 3;
    const desktop = parseFloat(slider.dataset.slidesDesktop) || 4;
    const desktopXl = parseFloat(slider.dataset.slidesDesktopXl) || 5;

    new Swiper(slider, {
      slidesPerView: mobile,
      spaceBetween: 8,
      breakpoints: {
        768: {
          slidesPerView: tablet
        },
        1024: {
          slidesPerView: desktop
        },
        1368: {
          slidesPerView: desktopXl
        }
      }
    });
  });

  document.querySelectorAll('.fc-swiper').forEach((slider) => {
    const section = slider.closest('.fc-slider');

    new Swiper(slider, {
      loop: true,
      slidesPerView: parseFloat(section.dataset.mobile) || 1.2,
      spaceBetween: 30,
      centeredSlides: true,

      navigation: {
        nextEl: section.querySelector('.fc-next'),
        prevEl: section.querySelector('.fc-prev'),
      },

      breakpoints: {
        768: {
          slidesPerView: parseFloat(section.dataset.tablet) || 2,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: parseFloat(section.dataset.desktop) || 4,
          centeredSlides: false,
        }
      }
    });
  });

  initGzAnimations();
});


const SELECTOR = '.gzanimate';
const INIT_CLASS = 'gz-init';
const ACTIVE_CLASS = 'gzanimated';

function initGzAnimations(scope = document) {
    const elements = scope.querySelectorAll(SELECTOR);

    if (!elements.length) return;

    elements.forEach((el) => {
    if (el.classList.contains(INIT_CLASS)) return;
    el.classList.add(INIT_CLASS);

    Motion.inView(
        el,
        () => {
        if (!el.classList.contains(ACTIVE_CLASS)) {
            const delay = parseInt(el.dataset.animateDelay || 0, 10);

            if (delay) {
            setTimeout(() => {
                el.classList.add(ACTIVE_CLASS);
            }, delay);
            } else {
            el.classList.add(ACTIVE_CLASS);
            }
        }
        },
        {
        margin: '0px 0px -11% 0px'
        }
    );
    });
}


document.addEventListener('shopify:section:load', (event) => {
    initGzAnimations(event.target);
});
